import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { Link } from "react-router-dom";
import img1 from "../assets/img/home/before_after/01.png";
import img2 from "../assets/img/home/before_after/02.png";
import img3 from "../assets/img/home/before_after/03.png";
import img4 from "../assets/img/home/before_after/04.png";
import img5 from "../assets/img/home/before_after/05.png";
import img6 from "../assets/img/home/before_after/06.jpg";
import img7 from "../assets/img/home/before_after/07.jpg";
import img8 from "../assets/img/home/before_after/08.jpg";
import img9 from "../assets/img/home/before_after/09.jpg";
import img10 from "../assets/img/home/before_after/10.jpg";
import img11 from "../assets/img/home/before_after/11.jpg";
import img12 from "../assets/img/home/before_after/12.jpg";
import img13 from "../assets/img/home/before_after/13.jpg";
import img14 from "../assets/img/home/before_after/14.jpg";
import img15 from "../assets/img/home/before_after/15.jpg";
import img16 from "../assets/img/home/before_after/16.jpg";
import img17 from "../assets/img/home/before_after/17.png";
const BeforeAfter = () => {
  const beforeAfterHome = [
    {
      id: 1,
      imageUrl: `${img1}`,
      alt: "Alopecia Areata",
    },
    {
      id: 2,
      imageUrl: `${img2}`,
      alt: "Vitiligo",
    },
    {
      id: 3,
      imageUrl: `${img3}`,
      alt: "acne ",
    },
    {
      id: 4,
      imageUrl: `${img4}`,
      alt: "psoriasis",
    },
    {
      id: 5,
      imageUrl: `${img5}`,
      alt: "Androgenic Alopecia",
    },
    {
      id: 6,
      imageUrl: `${img6}`,
      alt: "",
    },
    {
      id: 7,
      imageUrl: `${img7}`,
      alt: "",
    },
    {
      id: 8,
      imageUrl: `${img8}`,
      alt: "",
    },
    {
      id: 9,
      imageUrl: `${img9}`,
      alt: "",
    },
    {
      id: 10,
      imageUrl: `${img10}`,
      alt: "",
    },
    {
      id: 11,
      imageUrl: `${img11}`,
      alt: "",
    },
    {
      id: 12,
      imageUrl: `${img12}`,
      alt: "",
    },
    {
      id: 13,
      imageUrl: `${img13}`,
      alt: "",
    },
    {
      id: 14,
      imageUrl: `${img14}`,
      alt: "",
    },
    {
      id: 15,
      imageUrl: `${img15}`,
      alt: "",
    },
    {
      id: 16,
      imageUrl: `${img16}`,
      alt: "",
    },
    {
      id: 17,
      imageUrl: `${img17}`,
      alt: "",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cseEase: "linear",
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    swipeToSlide: true,
  };
  return (
    <>
      <div className="container" id="before-after-home" data-aos="fade-up">
        <div className="row justify-content-center align-items-center">
          <div className="col-md-6 order-md-1 order-2 mb-md-0 mb-3">
            <div className="need-heading">
              <h2 className="text-center text-til my-3">
                BEFORE & AFTER GALLERY
              </h2>
            </div>
            <div className="col-content mt-md-5 mt-2" data-aos="fade-up">
              <p>
                We are CUTIS Academy of Cutaneous Sciences (CACS), with the
                training, expertise, and high-level skills to make you look and
                feel at your very best.
              </p>
              <p>
                We are confident in our ability to achieve outstanding results
                for our patients. Check out the before and after images to see
                the differences.
              </p>
            </div>
          </div>
          <div className="col-md-6 order-md-2 order-1" data-aos="fade-up">
            <Slider {...settings}>
              {beforeAfterHome.map((value, index) => (
                <img
                  src={value.imageUrl}
                  alt=""
                  className="img-fluids"
                  key={index}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeforeAfter;
